var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:("btn button-add text-white d-flex justify-content-center align-items-center btn-none " + _vm.size),attrs:{"to":_vm.route,"variant":"none"}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }